import axios from "./index";
import { ERROR1, ERROR_500 } from "../constants";


export const getGoogleAuthSecret = async () => {
    try {
        const { data } = await axios({
            method: "GET",
            url: "/profile/user/security/topt/secret"
        });

        return {
            succeed: true,
            data: data.data
        };
    } catch (err) {
        let errMsg =
            err?.response?.data?.errorMessage ||
            ERROR1;

        if (err?.response?.data?.errorCode === ERROR_500) {
            errMsg =
                "There's something wrong retrieving the Google Authenticator secret. Please try again later.";
        }
        return {
            succeed: false,
            message: errMsg
        };
    }
};